import React from "react";
import { Switch, Redirect } from "react-router-dom";
import { AdminProtectedRoute, AdminGuestRoute } from "./AdminRouteProtection";
import { ADMIN_ROUTES } from "./AdminPaths";

// Auth Pages
import AdminLogin from "../../pages/Admin/AdminLogin";
import AdminForgotPassword from "../../pages/Admin/AdminForgotPassword";
import AdminResetPassword from "../../pages/Admin/AdminResetPassword";
import AdminChangePassword from "../../pages/Admin/AdminChangePassword";

// Admin Pages (NEW - URL-based routing)
import Dashboard from "../../pages/Admin/Dashboard";
import UsersPage from "../../pages/Admin/UsersPage";
import UserDetailPage from "../../pages/Admin/UserDetailPage";
import RoomsPage from "../../pages/Admin/RoomsPage";
import SessionsPage from "../../pages/Admin/SessionsPage";
import PaymentsPage from "../../pages/Admin/PaymentsPage";
import PaymentDetailPage from "../../pages/Admin/PaymentDetailPage";
import AnalyticsPage from "../../pages/Admin/AnalyticsPage";
import AdsPage from "../../pages/Admin/AdsPage";
import NotificationsPage from "../../pages/Admin/NotificationsPage";
import EconomyPage from "../../pages/Admin/EconomyPage";
import AdminsPage from "../../pages/Admin/AdminsPage";
import ActivityLogsPage from "../../pages/Admin/ActivityLogsPage";
import ReportsPage from "../../pages/Admin/ReportsPage";
import SettingsPage from "../../pages/Admin/SettingsPage";

const AdminRouter = () => (
  <Switch>
    {/* Auth Routes - Guest only */}
    <AdminGuestRoute exact path={ADMIN_ROUTES.root} component={AdminLogin} />
    <AdminGuestRoute exact path={ADMIN_ROUTES.login} component={AdminLogin} />
    <AdminGuestRoute
      exact
      path={ADMIN_ROUTES.forgotPassword}
      component={AdminForgotPassword}
    />
    <AdminGuestRoute
      exact
      path={ADMIN_ROUTES.resetPassword}
      component={AdminResetPassword}
    />

    {/* Protected Routes - Authenticated only */}
    <AdminProtectedRoute exact path={ADMIN_ROUTES.dashboard} component={Dashboard} />
    <AdminProtectedRoute
      exact
      path={ADMIN_ROUTES.changePassword}
      component={AdminChangePassword}
    />

    {/* Management Routes with proper URLs */}
    <AdminProtectedRoute exact path={ADMIN_ROUTES.users} component={UsersPage} />
    <AdminProtectedRoute exact path={ADMIN_ROUTES.userDetail} component={UserDetailPage} />
    <AdminProtectedRoute exact path={ADMIN_ROUTES.rooms} component={RoomsPage} />
    <AdminProtectedRoute exact path={ADMIN_ROUTES.sessions} component={SessionsPage} />
    <AdminProtectedRoute exact path={ADMIN_ROUTES.payments} component={PaymentsPage} />
    <AdminProtectedRoute exact path={ADMIN_ROUTES.paymentDetail} component={PaymentDetailPage} />
    <AdminProtectedRoute exact path={ADMIN_ROUTES.analytics} component={AnalyticsPage} />
    <AdminProtectedRoute exact path={ADMIN_ROUTES.ads} component={AdsPage} />
    <AdminProtectedRoute exact path={ADMIN_ROUTES.notifications} component={NotificationsPage} />
    <AdminProtectedRoute exact path={ADMIN_ROUTES.economy} component={EconomyPage} />
    <AdminProtectedRoute exact path={ADMIN_ROUTES.admins} component={AdminsPage} />
    <AdminProtectedRoute exact path={ADMIN_ROUTES.logs} component={ActivityLogsPage} />
    <AdminProtectedRoute exact path={ADMIN_ROUTES.reports} component={ReportsPage} />
    <AdminProtectedRoute exact path={ADMIN_ROUTES.settings} component={SettingsPage} />

    {/* Default redirect */}
    <Redirect to={ADMIN_ROUTES.login} />
  </Switch>
);

export default AdminRouter;
